import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Switch from "@mui/material/Switch";
import { Card, Grid, Tooltip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

export default class Courses extends Component {
  state = {
    courses: [],
    per_page: 10,
    page_no: 1,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      totalDocs: 0,
      limit: 10,
    },
    notification: false,
    message: "",
    notiColor: "success",
    loading: false,
  };

  componentDidMount() {
    this.getAllCourses(this.state.page_no, this.state.per_page);
  }

  // 🔥 POST API
  getAllCourses = async (page = 1, limit = 10) => {
    this.setState({ loading: true });

    if (init() !== "success") return;

    try {
      const resp = await axios.post(Constants.getUrls.getAllCourses, {
        page,
        limit,
      });

      if (resp.data.status) {
        const data = resp.data.data.rows || [];
        const pg = resp.data.data.pagination;

        this.setState({
          courses: data,
          pagination: {
            page: pg.currentPage,
            totalPages: pg.totalPages,
            hasNextPage: pg.hasNextPage,
            hasPrevPage: pg.hasPrevPage,
            totalDocs: pg.total,
            limit: pg.limit,
          },
          loading: false,
        });
      } else {
        this.setState({
          notification: true,
          message: resp.data.message,
          loading: false,
          notiColor: "warning",
        });
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: "Something went wrong!",
        loading: false,
        notiColor: "warning",
      });
    }
  };

  handlePageChange = (page) => {
    this.getAllCourses(page, this.state.per_page);
  };

  handleEntriesPerPageChange = (limit) => {
    this.setState({ per_page: limit }, () => {
      this.getAllCourses(1, limit);
    });
  };

  // 🔥 Delete
  handleDelete = async (id) => {
    if (!window.confirm("Delete this course?")) return;

    try {
      const resp = await axios.post(Constants.deleteUrls.deleteCourses, { id });

      this.setState({
        notification: true,
        message: resp.data.message || "Deleted successfully",
        notiColor: "success",
      });

      this.getAllCourses(this.state.pagination.page, this.state.per_page);
    } catch (err) {
      this.setState({
        notification: true,
        message: "Delete failed!",
        notiColor: "warning",
      });
    }
  };

  // 🔥 Status Toggle
  handleStatusChange = async (id, currentStatus) => {
    const newStatus = currentStatus == 1 ? 0 : 1;

    try {
      const resp = await axios.post(Constants.putUrls.updateCourseStatus, {
        id,
        status: newStatus,
      });

      this.setState({
        notification: true,
        message: resp.data.message || "Status updated",
      });

      this.getAllCourses(this.state.pagination.page, this.state.per_page);
    } catch (err) {
      this.setState({
        notification: true,
        message: "Status update failed!",
      });
    }
  };

  render() {
    const { courses, pagination, loading } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Courses List
              </MDTypography>
            </MDBox>

            {/* Create Button */}
            <Grid item sm={4} px={2} align="right">
              <Link to="/addcourses">
                <MDButton variant="contained" color="primary">
                  Create Course
                </MDButton>
              </Link>
            </Grid>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : courses.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial" },
                      { Header: "Image", accessor: "image" },
                      { Header: "Course Name", accessor: "course_name" },
                      { Header: "Level", accessor: "level" },
                      { Header: "Status", accessor: "status" },
                      { Header: "Actions", accessor: "action" },
                    ],

                    rows: courses.map((item, index) => ({
                      serial:
                        (pagination.page - 1) * pagination.limit +
                        (index + 1),

                      image: (
                        <img
                          src={Constants.imageDomain + item.image_path}
                          style={{
                            width: 50,
                            height: 50,
                            borderRadius: 6,
                            objectFit: "cover",
                          }}
                        />
                      ),

                      course_name: item.course_name,

                      level: item.level_name, // ✅ instead of role_id

                      status: (
                        <Switch
                          checked={item.status == 1}
                          onChange={() =>
                            this.handleStatusChange(item.id, item.status)
                          }
                          color="info"
                        />
                      ),

                      action: (
                        <div style={{ display: "flex", gap: 10 }}>
                          <Tooltip title="Edit">
                            <Link to={`/updatecourses/${item.id}`}>
                              <IconButton color="info">
                                <EditIcon />
                              </IconButton>
                            </Link>
                          </Tooltip>

                          <Tooltip title="Delete">
                            <IconButton
                              color="error"
                              onClick={() =>
                                this.handleDelete(item.id)
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              ) : (
                <div style={{ padding: 20 }}>No Courses Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              title="Courses"
              content={this.state.message}
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}